import React, { useEffect, useState } from 'react';

import {
  Field,
  reduxForm,
} from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';

import FormInputText from '../../../components/global/form-input-text';
import TranslatedCopy from '../../../intl/translated-copy';
import KeyMap from '../../../utilities/keymap';
import userProfileAccountValidation from '../../../validation/user-profile/user-profile-account/user-profile-account-validation';
import { USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID } from '../../../constants/form-ids';

import FormOtpLogin from '../../profile/form-otp-login';

import UserProfileRecoverPasswordForm from './user-profile-recover-password-form';
import { recoverOtpSettingsReset, sendRecoverAccountPasswordPin } from '../../../../redux/actions';
import LoadingScreen from '../../global/loading-screen';

import { returnFfnLeadingZeros } from '../../../utilities/helpers';
import { recoverPasswordMicroTypeErrors } from '../../../constants/user-profile-recover-password-codes';
import UserProfileErrorDisconnection from '../user-profile-error-disconnection';
import UserProfileRecoverPinForm from './user-profile-recover-pin-form';

const mapStateToProps = state => {
  return ({
    apiError: state.Manage.apiError,
    dispatch: state.dispatch,
    language: state.Manage.language,
    passwordPinResetForm: state.form[USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID],
    profileOtpSettings: state.Manage.profileOtpSettings,
    profileRecoverPasswordPin: state.Manage.profileRecoverPasswordPin,
    stateStoreFront: state.Manage.stateStoreFront,
  });
};

let UserProfileAccountNumberForm = (props) => {
  const {
    handleBackButtonClick,
    handleCloseModalLogin,
    invalid,
    profileOtpSettings: {
      recoverOtpSettingsError = null,
      recoverOtpSettingsLoading,
      recoverOtpSettingsSent = null,
    },
    optionSelected,
    profileRecoverPasswordPin: {
      recoverPasswordPinSent = null,
    },
    reset,
    stateStoreFront: {
      recoverAccountProfile,
    },
    toggleRecoveryAccount,
  } = props;

  const [showOtpScreen, setShowOtpScreen] = useState(true);
  const [otpCode, setOtpCode] = useState('');
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [amAccount, setAmAccount] = useState(null);
  const [reSendOtp, setResendOtp] = useState(false);

  useEffect(() => {
    if (!recoverOtpSettingsLoading) {
      setResendOtp(false);
    }
  }, [recoverOtpSettingsLoading]);

  useEffect(() => {
    if (recoverOtpSettingsSent?.maskedEmail) {
      reset();
    }
  }, [recoverOtpSettingsSent]);

  const handleAccountModal = () => {
    const {
      dispatch,
      language,
    } = props;

    const eventCode = language === 'es' ? 'ESP' : 'ENG';
    const data = {
      accountNumber: returnFfnLeadingZeros(amAccount),
      eventCode: `OTP_ACCESS_${eventCode}`,
      passwordPin: false,
    };

    dispatch(sendRecoverAccountPasswordPin(data));
  };

  const handleBackButtonOtpForm = () => {
    const {
      dispatch,
    } = props;

    dispatch(recoverOtpSettingsReset());
  };

  const onEnterClick = (e) => {
    if ((e.keyCode === KeyMap.ENTER || e.keyCode === KeyMap.RETURN)) {
      handleAccountModal();
    }
  };

  const handleCheckOtpCode = (otpCode) => {
    setOtpCode(otpCode);
    setOtpSuccess(true);
  };

  const handleOtpValidSubmit = () => {
    setShowOtpScreen(false);
  };

  const handleSubmitPasswordPinForm = (value, isPin = false) => {
    const {
      dispatch,
      language,
    } = props;

    const propValue = !isPin ? 'newPassword' : 'newNip';
    const eventCode = language === 'es' ? 'ESP' : 'ENG';
    const data = {
      accountNumber: returnFfnLeadingZeros(amAccount),
      eventCode: `OTP_ACCESS_${eventCode}`,
      [propValue]: value,
      otpCode: otpCode,
      passwordPin: true,
    };

    dispatch(sendRecoverAccountPasswordPin(data));
  };

  const handleClickBackPasswordForm = ({ otpError, microError }) => {
    if (!otpError || microError) {
      handleBackButtonClick();
    } else if (otpError) {
      setShowOtpScreen(true);
      setOtpSuccess(false);
    }
  };

  const handleChangeAmAccountField = (event) => {
    const value = event.target.value;

    setAmAccount(value);
  };

  const handleResendOtpCode = () => {
    setResendOtp(true);
    handleAccountModal();
  };

  const FormClasses = cx('UserProfileAccountNumberForm-container', {
    'UserProfileAccountNumberForm-container--Loading': recoverOtpSettingsLoading,
  });

  const {
    code = null,
  } = recoverOtpSettingsError || {};

  const {
    maskedEmail = null,
  } = recoverOtpSettingsSent || {};

  const {
    maskedEmail: maskEmailPass = null,
  } = recoverPasswordPinSent || {};

  const microError = Boolean(recoverPasswordMicroTypeErrors.includes(code) || code >= 500);
  const showNextScreen = Boolean(maskedEmail || maskEmailPass);
  const showLoading = Boolean(recoverOtpSettingsLoading);

  const copyTitle = optionSelected === 1 ? 'PRO_HOME_PASSWORD_TITLE' : 'PRO_HOME_NIP_TITLE';
  const copyDescription = optionSelected === 1 ? 'PRO_HOME_PASSWORD_DESCRIPTION' : 'PRO_HOME_NIP_DESCRIPTION';
  const copyLabelField = optionSelected === 1 ? 'PRO_HOME_PASSWORD_ACCOUNT' : 'PRO_HOME_NIP_ACCOUNT';
  const copyButton = optionSelected === 1 ? 'PRO_HOME_PASSWORD_BUTTON' : 'PRO_HOME_NIP_BUTTON';

  const RecoverAccountClass = cx({
    'UserProfileRecoverAccount-link': !recoverAccountProfile,
  });


  return (
    (showNextScreen || reSendOtp) ?
      showOtpScreen ?
        <FormOtpLogin
          emailCopy={ maskedEmail }
          handleBackButtonClick={ handleBackButtonOtpForm }
          handleClick={ handleResendOtpCode }
          handleCheckOtpCode={ handleCheckOtpCode }
          handleOtpValidSubmit={ handleOtpValidSubmit }
          isOtpSuccess={ otpSuccess }
          showErrorAndHideButton={ true }
        />
        :
        optionSelected === 1 ?
          <UserProfileRecoverPasswordForm
            handleBackButtonClick={ handleClickBackPasswordForm }
            onCloseModal={ handleCloseModalLogin }
            onSubmitForm={ handleSubmitPasswordPinForm }
          />
          :
          <UserProfileRecoverPinForm
            onBackButtonClick={ handleClickBackPasswordForm }
            onCloseModal={ handleCloseModalLogin }
            onSubmitForm={ (codePin) => handleSubmitPasswordPinForm(codePin, true) }
          />
      :
      !microError ?
        <>
          { showLoading &&
            <LoadingScreen
              seatmap={ true }
              isDataLoading={ true }
              type='airplaneWindow' />
          }
          <div className={ FormClasses }>
            <button
              className='UserProfileRecoverPasswordOrPin-back'
              onClick={ handleBackButtonClick }
              type='button'>
              <span className='Icon Icon--calendarArrowLeft' />
              <TranslatedCopy
                className='UserProfileRecoverPasswordOrPin-back-Text'
                copyID='PRO_HOME_FORGOT_LOGIN' />
            </button>
            <h1 className='UserProfileAccountNumberForm-title'>
              <TranslatedCopy copyID={ copyTitle } />
            </h1>
            <h5 className='UserProfileAccountNumberForm-subtitle'>
              <TranslatedCopy copyID={ copyDescription } />
            </h5>
            <div className='LoginModalForm-section'>
              <div key='inputUser' onKeyDown={ (e) => onEnterClick(e) } >
                <Field
                  className='LoginModalForm-formInput UserProfileLogin-formInput UserProfileLoginForm-home'
                  component={ FormInputText }
                  isRequired={ true }
                  key='inputEmailCPNumber'
                  labelCopyID={ copyLabelField }
                  name='clubPremierNumber'
                  onChange={ handleChangeAmAccountField }
                  type={ 'number' }
                />
              </div>
              <div className={ RecoverAccountClass }>
                { recoverAccountProfile &&
                  <button
                    onClick={ () => toggleRecoveryAccount(optionSelected) }
                    className='UserProfileLoginForm-forgotPassword-inline'
                    type='button'>
                    <TranslatedCopy copyID='PRO_HOME_FORGOT_USER' />
                  </button>
                }
              </div>
            </div>
            <div className='UserProfileRecoverPasswordOrPin-button'>
              <button
                className='Btn'
                disabled={ invalid }
                onClick={ handleAccountModal }>
                <TranslatedCopy copyID={ copyButton } />
              </button>
            </div>
            <TranslatedCopy
              className='UserProfileRecoverPasswordOrPin-captcha'
              copyID='PRO_HOME_FORGOT_CAPTCHA'
              tagName='p'
            />
          </div>
        </>
        :
        <UserProfileErrorDisconnection
          onBackButtonClick={ handleCloseModalLogin }
          handleBackButtonClick={ handleBackButtonClick }
        />
  );
};

UserProfileAccountNumberForm = reduxForm({
  destroyOnUnmount: true,
  form: USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID,
  validate: userProfileAccountValidation,
})(UserProfileAccountNumberForm);

UserProfileAccountNumberForm = connect(mapStateToProps)(UserProfileAccountNumberForm);

export default UserProfileAccountNumberForm;
